<template>
    <div class="space-y-4">
        <div v-for="course in courses" class="rounded-2xl border-1 p-4 space-y-4" :key="course.course_id" @click="openBookingModal(course)">
            <div class="flex gap-4 items-center">
                <img :src="teacherImagePath + (course.instructor_image || 'ansatte-placeholder.png')" :alt="course.instructor_name + ' ' + $t('bilde')" class="w-10 h-10 rounded-full object-cover border border-slate-200" />
                <div class="text-xl font-bold">{{ course.instructor_name }}</div>
            </div>


            <div class="text-sm gap-2 flex flex-col">
                <div class="text-xs">{{ course.instructor_name}}</div>
                <div class="text-xs">{{ course.class_short_name }}</div>
                <div class="text-xs">{{ course.product_name }}</div>
                <div class="text-xs">{{ course.time_from_to }}</div>
                <div class="text-xs">{{ priceFormat(course.price) }}</div>
                <div class="text-xs">{{ course.location }}</div>
                <div class="">
                    <div class="bg-primary px-4 py-2 text-white rounded-xl cursor-pointer">{{ $t('Bestill') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import {ref} from 'vue';

    defineProps ({
        courses: {
            type: Array,
            required: true
        },
        teacherImagePath: {
            type: String,
            required: true
        },

    });

    const isLoadingModal = ref(false)



    function openBookingModal(course) {
        if (isLoadingModal.value) {
            return;
        }
        isLoadingModal.value = true

        TABS.api.loadCourse(null, course.course_id, course.class_id, course.office_id, () => {
            isLoadingModal.value = false;
        })
    }

    function priceFormat(price) {
        return price ? window.TABS.L10n.money.parse(price).format() : '';
    }

</script>